import colors from 'vuetify/util/colors';
import { AppColors } from '@/themes/theme';

export const jikordColors: Partial<AppColors> = {
  systemPrimary: '#3A5877',
  systemSecondary: '#3A5877',
  buttonPrimary: '#3A5877',
  buttonWarning: colors.red.darken1,
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  primary: '#3A5877',
  rdpbackground: '#d4d4d4',
  leftpanelhover: '#c46064',
};
